import React from "react";
import {ImageConfig} from "../../../../constants";
import "./SuccessStatusComponent.scss";
import moment from "moment";
import {CommonService} from "../../../../shared/services";

interface SuccessStatusComponentProps {
    clientDetails: any;
}

const SuccessStatusComponent = (props: SuccessStatusComponentProps) => {
    const {clientDetails} = props;

    return (
        <div className="success-status-container">
            <div className="confirmation-status">
                <div className="confirmation-status-icon">
                    <img src={ImageConfig.Tick} alt="Tick"/>
                </div>
                <h2 className="confirmation-status-text">Submitted Successfully!</h2>

                <div className="confirmation-status-sub-text">
                    {clientDetails?.request_type === 'request_access' &&
                        <div>You have successfully requested access to the <br/> following account:</div>}
                    {clientDetails?.request_type === 'grant_access' &&
                        <div>You have successfully sent a request to grant<br/>account access to the following account
                            holder:</div>}
                </div>
                <div className="account-details">
                    <p>
                        <strong>Client ID:</strong> <span
                        className={'client-details others'}>&nbsp;{clientDetails?.client_id}</span>
                    </p>
                    <p>
                        <strong>Client Name:</strong> <span
                        className={'client-details'}>{clientDetails?.first_name} {clientDetails?.last_name}</span>
                    </p>
                    <p>
                        <strong>D.O.B:</strong><span
                        className={'client-details others2'}>&nbsp;&nbsp; {moment(clientDetails?.dob).format('DD-MMM-YYYY')}</span>
                    </p>
                    <p>
                        <strong>Phone:</strong><span
                        className={'client-details others2'}>&nbsp; {CommonService.formatPhoneNumber(clientDetails?.phone)}</span>
                    </p>
                </div>

                {/* Email Info */}
                <div className="confirmation-status-sub-text">
                    {
                        clientDetails?.request_type === 'request_access' &&
                        <div> An email has been sent to the account owner for <br/> access approval.</div>

                    }
                    {
                        clientDetails?.request_type === 'grant_access' &&
                        <div> A notification email has been sent to the account owner.</div>

                    }

                </div>
            </div>
            {/* Note at the Bottom */}
            <p className="confirmation-text-footer">
                {clientDetails?.request_type === 'request_access' &&
                    <div>Note: You will not have access to the requested account until the
                        account holder approves your request.</div>}
                {clientDetails?.request_type === 'grant_access' &&
                    <div>Note: The other account owner will not have access to your account <br/> until they approve
                        your request. </div>}
            </p>

        </div>
    );
};

export default SuccessStatusComponent;
